import React, { useState } from 'react';
import { useToast } from '../contexts/ToastContext';

const ForgotPasswordModal = ({ onClose, onSwitchToLogin }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { addToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    try {
      const response = await fetch('/api/v1/password/forgot', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        addToast(data.message, 'success');
        onClose();
      } else {
        setError(data.error || 'An error occurred.');
      }
    } catch (err) {
      setError('An unexpected network error occurred.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Forgot Password</h2>
          <button aria-label="Close" className="close-button" onClick={onClose}>&times;</button>
        </header>
        <p>Enter your email address and we will send you a link to reset your password.</p>
        <form onSubmit={handleSubmit}>
          {error && <p style={{ color: 'var(--pico-color-red-550)' }}>{error}</p>}
          <label htmlFor="forgot-email">Email</label>
          <input
            type="email"
            id="forgot-email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isSubmitting}
          />
          <button type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send Password Reset Email'}
          </button>
          <p style={{ textAlign: 'center', marginTop: '1rem' }}>
            <small>
              Remembered your password?{' '}
              <a href="#" onClick={(e) => { e.preventDefault(); onSwitchToLogin(); }}>Log In</a>
            </small>
          </p>
        </form>
      </article>
    </div>
  );
};

export default ForgotPasswordModal;